import { getIsDarkTheme } from 'owa-fabric-theme';
import type { IEditor } from 'roosterjs-editor-types';
import {
    SONORA_INLINE_HINT_CLASS,
    SONORA_ZERO_QUERY_HINT_PARENT,
    WHITE_SPACE,
    SUGGESTION_TEXT_COLOR,
    SUGGESTION_TEXT_COLOR_DARK,
} from '../../constants';

const createZeroQueryHintNode = (editor: IEditor, hintText: string): HTMLElement => {
    const editorDocument = editor.getDocument();

    const span = editorDocument.createElement('span');
    span.id = SONORA_ZERO_QUERY_HINT_PARENT;
    span.className = SONORA_INLINE_HINT_CLASS;
    span.style.whiteSpace = WHITE_SPACE;
    span.style.color = getIsDarkTheme() ? SUGGESTION_TEXT_COLOR_DARK : SUGGESTION_TEXT_COLOR;
    span.setAttribute('contenteditable', 'false');

    const textNode = editorDocument.createTextNode(` ${hintText}`);
    span.appendChild(textNode);

    return span;
};

export default createZeroQueryHintNode;
